<template>
    <div class="row">
        <div class="position-relative w-100 mb-5">
            <div class="w-100 d-flex justify-content-between align-items-center">
                <h4 class="py-3">Staff</h4>
                <template v-if="canAddStaff">
                    <add-user
                        :organization="organization"
                        :subscription="subscription"
                        :roles="roles"
                        @update-list="fetchTherapists()"
                        dusk="add-user"
                    >
                        Add User
                    </add-user>
                </template>
                <template v-else="">
                    <a class="btn btn-sm text-white btn-light cursor-not-allowed"
                        >Add new therapist</a
                    >
                </template>
            </div>
            <tabs :filter="filter" :tabs="tabs" @set-parent-prop="updateFilter($event)"></tabs>

            <div class="alert alert-info mt-3">
                To manage user roles and send, resend or cancel invites, go to
                <a href="/control-center">Control Center</a> &gt; User Accounts.
            </div>

            <div class="my-3 px-3 form-group row">
                <input
                    type="text"
                    class="form-control form-control-sm col-8 col-sm-4"
                    v-model="search"
                    placeholder="Search by First or Last Name"
                />
                <button
                    class="btn btn-sm btn-primary font-weight-bold text-uppercase mx-3"
                    @click="fetchTherapists()"
                >
                    Search
                </button>
            </div>

            <paginator :pagination="pagination" @fetch="fetchTherapists($event)"></paginator>

            <div class="mb-3">
                <div class="row">
                    <div class="col-12">
                        <div class="row mx-0 px-2" style="background-color: #323336">
                            <div class="col-3 px-1">
                                <small class="text-uppercase text-white">Name</small>
                            </div>
                            <div class="col-3 px-1">
                                <small class="text-uppercase text-white">Title</small>
                            </div>
                            <div class="col-3 px-1">
                                <small class="text-uppercase text-white">Supervisor</small>
                            </div>
                            <div class="col-3 px-1">
                                <small class="text-uppercase text-white">Mobile Phone</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mx-0">
                    <div class="col-12">
                        <div v-for="t in therapists" class="row p-2 list-item bg-white" :class="">
                            <div class="px-1 col-3">
                                <a
                                    class="text-primary cursor-pointer"
                                    :href="`/therapists/${t.id}/details`"
                                    >{{ t.user.name }}</a
                                >
                            </div>
                            <div class="px-1 col-3">
                                <span>{{
                                    t.therapist_types && t.therapist_types.length
                                        ? t.therapist_types[0].title
                                        : ""
                                }}</span>
                            </div>
                            <div class="px-1 col-3">
                                <span>{{ t.supervisor_user ? t.supervisor_user.name : "" }}</span>
                            </div>
                            <div
                                class="px-1 col-3 d-flex justify-content-between align-items-center"
                            >
                                <span>{{ helpers.formatPhone(t.mobile_phone) }}</span>
                                <button
                                    class="btn btn-sm btn-link text-black"
                                    type="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    :id="`archive-${t.user ? t.user.id : t.id}`"
                                >
                                    <i class="fa fa-ellipsis-v"></i>
                                </button>
                                <div
                                    v-if="!filter"
                                    class="dropdown-menu dropdown-menu-right"
                                    aria-labelledby="staff-actions"
                                >
                                    <a
                                        :class="
                                            canAddStaff
                                                ? 'text-danger cursor-pointer'
                                                : 'text-light cursor-not-allowed'
                                        "
                                        class="dropdown-item small actions"
                                        :id="`confirm-archive-${t.user ? t.user.id : t.id}`"
                                        @click="canAddStaff ? confirmArchive(t) : null"
                                    >
                                        Archive staff
                                    </a>
                                </div>
                                <div
                                    v-else=""
                                    class="dropdown-menu dropdown-menu-right"
                                    aria-labelledby="staff-actions"
                                >
                                    <a
                                        :class="
                                            canAddStaff
                                                ? 'text-danger cursor-pointer'
                                                : 'text-light cursor-not-allowed'
                                        "
                                        class="dropdown-item small actions"
                                        :id="`confirm-unarchive-${t.user ? t.user.id : t.id}`"
                                        @click="canAddStaff ? confirmUnarchive(t) : null"
                                    >
                                        Unarchive staff
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <paginator :pagination="pagination" @fetch="fetchTherapists($event)"></paginator>
        </div>

        <delete-confirmation
            :visible="deleteConfirmationVisible"
            :icon="'fa-archive'"
            :button-text="'Yes, archive staff'"
            @confirm="removeUser(deletePayload.user.id)"
            @close="resetDelete()"
        >
            <template slot="title">
                Archive {{ helpers._get(deletePayload, "name", "user") }}?
            </template>
            <template slot="description">
                <p>
                    <b>{{ organization.name }}</b
                    >'s subscription will decrease from <b>{{ subscription.quantity }}</b> to
                    <b>{{ subscription.quantity - 1 }}</b> seats.
                </p>
                <invoice-preview
                    :organization="organization"
                    :subscription="subscription"
                    ref="previewArchive"
                ></invoice-preview>
            </template>
        </delete-confirmation>

        <modal-component
            id="therapists-main-modal"
            :visible="selectedAccount"
            @close="resetModal()"
        >
            <!--UNARCHIVE USER FROM ORGANIZATION-->
            <div class="d-flex flex-column align-items-center">
                <i class="fa fa-3x text-primary fa-question-circle"></i>

                <h3 class="font-weight-bold text-center my-4">
                    Add {{ helpers._get(selectedAccount, "name", "this user") }}?
                </h3>

                <p class="text-center">
                    <b>{{ organization.name }}</b
                    >'s subscription will increase from <b>{{ subscription.quantity }}</b> to
                    <b>{{ subscription.quantity + 1 }}</b> seats.
                </p>

                <invoice-preview
                    :subscription="subscription"
                    ref="previewChange"
                    :organization="organization"
                ></invoice-preview>

                <div class="d-flex w-100 justify-content-between align-items-center py-3">
                    <button class="btn" @click="resetModal()">Cancel</button>
                    <button
                        id="handle-filter-user-action"
                        class="btn btn-primary font-weight-bold  text-white"
                        @click="addUser(selectedAccount.id)"
                    >
                        Yes, add user
                    </button>
                </div>
            </div>
        </modal-component>
    </div>
</template>
<script>
import { permissions } from "../../plugins/permissions";
import { pagination } from "../../plugins/pagination";
import { errors } from "../../plugins/errors";
import { deleteConfirmation } from "../../plugins/deleteConfirmation";
import Tabs from "../ui/Tabs";
import AddUser from "../widgets/AddUserWidget";
import InvoicePreview from "../widgets/UpcomingInvoicePreview";
import ModalComponent from "../ui/ModalComponent";
import { helpers } from "../../plugins/helpers";

export default {
    name: "TherapistsMain",
    props: ["organization", "subscription", "roles"],
    components: {
        Tabs,
        AddUser,
        InvoicePreview,
        ModalComponent,
    },
    mixins: [permissions, pagination, errors, deleteConfirmation],
    data() {
        return {
            helpers,
            filter: 0,
            tabs: ["Current Staff", "Archived Staff"],
            columns: [],
            therapists: [],
            search: null,
            selectedAccount: null,
            preview: null,
        };
    },
    watch: {
        organization() {
            if (this.organization) {
                this.initialize();
            }
        },
    },
    methods: {
        initialize() {
            this.fetchTherapists();
        },

        resetModal() {
            this.selectedAccount = null;
        },

        confirmArchive(account) {
            this.$refs.previewArchive.getUpcomingInvoicePreview(-1);
            //Endpoint takes the user id
            this.promptDelete(account);
        },

        confirmUnarchive(account) {
            this.$refs.previewChange.getUpcomingInvoicePreview(1);
            //Endpoint takes the therapist id
            this.selectedAccount = account;
        },

        updateFilter(event) {
            this.propSetFromChild(event);
            this.fetchTherapists();
        },

        fetchTherapists(page) {
            let queryString = "?";
            queryString += `&page=${page || this.page}`;
            queryString += this.filter ? `&with=archived` : "";
            queryString += this.search ? `&q=${this.search}` : "";
            axios
                .get(`/api/organizations/${this.organization.id}/therapists${queryString}`)
                .then(r => {
                    this.therapists = r.data.data;
                    this.pagination = r.data.meta;
                })
                .catch(error => {
                    console.error(error);
                });
        },

        removeUser(id) {
            helpers.toggleSpinner("handle-filter-user-action");
            axios
                .delete(`/api/organizations/${this.organization.id}/users/${id}`)
                .then(r => {
                    this.subscription.quantity--;
                    this.selectedAccount = null;
                    this.fetchTherapists();
                    helpers.toggleSpinner("handle-filter-user-action");
                    this.resetDelete();
                })
                .catch(e => {
                    console.error(e);
                    helpers.toggleSpinner("handle-filter-user-action");
                    this.resetDelete();
                });
        },

        addUser(id) {
            helpers.toggleSpinner("handle-filter-user-action");
            axios
                .post(`/api/organizations/${this.organization.id}/users/${id}/unarchive`)
                .then(r => {
                    this.subscription.quantity++;
                    this.selectedAccount = null;
                    this.fetchTherapists();
                    helpers.toggleSpinner("handle-filter-user-action");
                })
                .catch(e => {
                    console.error(e);
                    helpers.toggleSpinner("handle-filter-user-action");
                });
        },
    },
};
</script>

<style scoped lang="scss">
.list-item {
    border: solid 1px #bfbfbf;
}
.list-item:not(:first-child) {
    border-top: none;
}
</style>
